import { render, staticRenderFns } from "./TopLevelProductSelector.vue?vue&type=template&id=9a4b121a&scoped=true"
import script from "./TopLevelProductSelector.vue?vue&type=script&lang=ts"
export * from "./TopLevelProductSelector.vue?vue&type=script&lang=ts"
import style0 from "./TopLevelProductSelector.vue?vue&type=style&index=0&id=9a4b121a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4b121a",
  null
  
)

export default component.exports